import classNames from 'classnames';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { Colours } from '../../tokens';
import SVG from '../SVG';
const useStyles = createUseStyles({
    root: {
        color: Colours.primary,
    },
});
const CricleTickIcon = ({ className }) => {
    const styles = useStyles();
    return (React.createElement(SVG, { width: "16", height: "16", viewBox: "0 0 16 16", className: classNames(styles.root, className) },
        React.createElement("g", { transform: "translate(-748 -188)" },
            React.createElement("g", { transform: "translate(748 188)" },
                React.createElement("path", { d: "M6,12A6,6,0,1,0,0,6,6.018,6.018,0,0,0,6,12Z", transform: "translate(2 2)", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1" }),
                React.createElement("path", { d: "M0,2.251,2.251,4.5,6.762,0", transform: "translate(4.619 5.748)", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1" }),
                React.createElement("path", { d: "M0,0H16V16H0Z", fill: "none", opacity: "0" })))));
};
export default CricleTickIcon;
//# sourceMappingURL=CircleTickIcon.js.map